import {makeEnumTypeGuard} from '../../../../core/src/models/api/types/enumTypes';
import {
  IconAccentShade,
  isAccentShade,
  isIconAccentShade,
  resolveAccentShade,
} from '../../theme/semantic/accentSemanticStyles';
import {ThemeContextReader} from '../../theme/userThemeProvider';

export enum IconShade {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  INVERSE = 'inverse',
  DISABLED = 'disabled',

  INFO = 'info',
  SUCCESS = 'success',
  BRAND = 'brand',
  DANGER = 'danger',
  WARNING = 'warning',

  ON_BG_FILL = 'on-bg-fill',
  ON_BG_FILL_INVERSE = 'on-bg-fill-inverse',
}

export const isIconShade = makeEnumTypeGuard(IconShade);
export type IconColor = `${IconShade}` | IconAccentShade;

export function isIconColor(color: unknown): color is IconColor {
  return isIconShade(color) || isAccentShade(color);
}

export function resolveIconColor(color: IconColor): ThemeContextReader {
  if (isIconAccentShade(color)) {
    const {paletteColor, variant} = resolveAccentShade(color);
    return ({theme}) => theme.accent[paletteColor][variant];
  }

  return ({theme}) => theme.icon[color];
}
